export const Languages = Object.freeze({
    hy: 'hy',
    en: 'en',
})

export const PackageTypes = Object.freeze({
    Package: 'Package',
    Paid: 'Paid',
})
